import { assign, isArray } from "min-dash";

import { is } from "bpmn-js/lib/util/ModelUtil";

import { isAny } from "bpmn-js/lib/features/modeling/util/ModelingUtil";

import { hasPrimaryModifier } from "diagram-js/lib/util/Mouse";

import store from "@/store";

/**
 * A provider for BPMN 2.0 elements context pad
 */
export default function ContextPadProvider(
  config,
  injector,
  eventBus,
  contextPad,
  modeling,
  elementFactory,
  connect,
  create,
  popupMenu,
  canvas,
  rules,
  translate
) {
  config = config || {};

  contextPad.registerProvider(this);

  this._contextPad = contextPad;
  this._modeling = modeling;
  this._elementFactory = elementFactory;
  this._connect = connect;
  this._create = create;
  this._popupMenu = popupMenu;
  this._canvas = canvas;
  this._rules = rules;
  this._translate = translate;

  if (config.autoPlace !== false) {
    this._autoPlace = injector.get("autoPlace", false);
  }

  eventBus.on("create.end", 250, function(event) {
    var shape = event.context.shape;
    if (!hasPrimaryModifier(event)) {
      return;
    }
    var entries = contextPad.getEntries(shape);
    if (entries.replace) {
      entries.replace.action.click(event, shape);
    }
  });
}

ContextPadProvider.$inject = [
  "config.contextPad",
  "injector",
  "eventBus",
  "contextPad",
  "modeling",
  "elementFactory",
  "connect",
  "create",
  "popupMenu",
  "canvas",
  "rules",
  "translate"
];

ContextPadProvider.prototype.getContextPadEntries = function(element) {
  let [modeling, connect, rules] = [this._modeling, this._connect, this._rules];

  let actions = {};

  if (element.type === "label") {
    return actions;
  }

  // connect action
  function startConnect(event, element) {
    connect.start(event, element);
  }

  function canConnect(businessObject) {
    if (is(businessObject, "bpmn:EndEvent")) {
      return false;
    }

    if (is(businessObject, "bpmn:StartEvent")) {
      return false;
    }

    const result = isAny(businessObject, [
      "bpmn:FlowNode",
      "bpmn:InteractionNode",
      "bpmn:DataObjectReference",
      "bpmn:DataStoreReference"
    ]);

    return result;
  }

  if (canConnect(element.businessObject)) {
    assign(actions, {
      connect: {
        group: "connect",
        className: "bpmn-icon-connection-multi",
        title: "连接节点",
        action: { click: startConnect, dragstart: startConnect }
      }
    });
  }

  function removeElement(e) {
    modeling.removeElements([element]);
  }

  // delete element entry, only show if allowed by rules
  let deleteAllowed = rules.allowed("elements.delete", { elements: [element] });

  if (isArray(deleteAllowed)) {
    // was the element returned as a deletion candidate?
    deleteAllowed = deleteAllowed[0] === element;
  }

  const immortalTypes = ["bpmn:StartEvent", "bpmn:EndEvent"];

  function canDeleteNode(element) {
    if (deleteAllowed && immortalTypes.indexOf(element.type) > -1) {
      return false;
    }

    // The sequenceFlow connect startEvent
    if (element.source && element.source.type === "bpmn:StartEvent") {
      return false;
    }

    // Initiator
    if (element.businessObject.id === "Initiator") {
      return false;
    }

    return true;
  }

  if (canDeleteNode(element)) {
    assign(actions, {
      delete: {
        group: "edit",
        className: "bpmn-icon-trash",
        title: "删除",
        action: { click: removeElement }
      }
    });
  }

  function modifyElement() {
    store.commit("process/SET_NODE_VISIBLE", element);
    store.commit("process/SET_NODE_INFO", true);
  }

  const canModifyNodeTypes = [
    "bpmn:UserTask",
    "bpmn:ServiceTask",
    "bpmn:SequenceFlow"
  ];

  function canModifyNode(element) {
    const result = isAny(element.businessObject, canModifyNodeTypes);

    if (!result) return false;

    if (element.businessObject.id === "Initiator") {
      return false;
    }

    if (is(element.businessObject, "bpmn:SequenceFlow")) {
      return is(element.businessObject.sourceRef, "bpmn:ExclusiveGateway");
    }

    return true;
  }

  if (canModifyNode(element)) {
    assign(actions, {
      modify: {
        group: "model",
        className: "bpmn-icon-screw-wrench",
        title: "编辑",
        action: { click: modifyElement }
      }
    });
  }

  return actions;
};
